import * as React from 'react';
export const IcMicOff = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M7.07 12.69A5.2 5.2 0 017 12v-1a1 1 0 10-2 0v1a7 7 0 00.41 2.34l1.66-1.65zM12 2a3 3 0 00-3 3v5.76l6-6A3 3 0 0012 2zm3 18H9a1 1 0 000 2h6a1 1 0 100-2zm-3-5a3 3 0 003-3v-1.56L20.49 5a1.055 1.055 0 00-.745-1.799A1.053 1.053 0 0019 3.51L3.51 19A1.055 1.055 0 005 20.49l2.87-2.88A7 7 0 0019 12v-1a1 1 0 00-2 0v1a5 5 0 01-7.73 4.18l1.46-1.47A3 3 0 0012 15z'
      fill='currentColor'
    />
  </svg>
);
